import type { Store } from 'typesafe-actions';
import type { Request, Response } from 'express';
import type { LocationState } from 'history';

export type universalRouterProps = {
  store: Store;
  isServer?: boolean;
  res?: Response;
  req?: Request;
  initialChunks?: string[];
};

export class Location {
  readonly pathname: string = '/';
  readonly key?: string = '';
  readonly search?: string = '';
  readonly hash?: string = '';
  readonly state?: LocationState | null = {};
  readonly protocol?: string = '';
  constructor(init?: Partial<Location>) {
    Object.assign(this, init);
  }
}
